























import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: 'AppLoadingAnimation',
})
export default class LoadingAnimation extends Vue {
  @Prop()fullscreen!: boolean;
  @Prop()text!: string;
}
